"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSaveLabel = exports.StyledSave = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseTypographyElement = _interopRequireDefault(require("@tvg/fuse-typography-element"));
var _fuseTappableArea = _interopRequireDefault(require("@tvg/fuse-tappable-area"));
var _Favorite = _interopRequireDefault(require("@tvg/fuse-icons/lib/Favorite"));
var _fuseUtils = require("@tvg/fuse-utils");
var _config = require("./config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var styledLabel = _config.stylesConfig.styledLabel,
  styledSave = _config.stylesConfig.styledSave;
var StyledSave = exports.StyledSave = _styledComponents["default"].button.attrs({
  className: 'fuse-save'
}).withConfig({
  displayName: "styled-save__StyledSave",
  componentId: "sc-1499957-0"
})(["align-items:center;background:none;border:none;cursor:pointer;display:flex;padding:", ";position:relative;", " &:focus{", "}&:hover [class*='fuse-icon'],&:focus [class*='fuse-icon']{background:var(--color-brand-mid);}&:hover [class*='fuse-save__icon--saved']:after{content:'';display:block;background:var(--color-global-black);mask:url('data:image/svg+xml,", "');-webkit-mask:url('data:image/svg+xml,", "');width:100%;}"], styledSave.padding, _fuseTappableArea["default"], _fuseUtils.FocusCss, encodeURIComponent((0, _server.renderToStaticMarkup)( /*#__PURE__*/_react["default"].createElement(_Favorite["default"], null))), encodeURIComponent((0, _server.renderToStaticMarkup)( /*#__PURE__*/_react["default"].createElement(_Favorite["default"], null))));
var StyledSaveLabel = exports.StyledSaveLabel = (0, _styledComponents["default"])(_fuseTypographyElement["default"]).attrs({
  className: 'fuse-save__label'
}).withConfig({
  displayName: "styled-save__StyledSaveLabel",
  componentId: "sc-1499957-1"
})(["margin:", ";"], styledLabel.margin);